import { getCurrentContext } from '..';

it('getCurrentContext', () => {
  expect(getCurrentContext).toThrowError();
});
